import { setOpenPopupData } from 'actions/damActions';
import { CLOSE_OPEN_POPUP, SET_OPEN_POPUP } from 'actions/types';

const initialState = {
  open: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_POPUP:
      return {
        ...state,
        open: true,
        data: action.payload,
      }; //CLOSE_OPEN_POPUP
    case CLOSE_OPEN_POPUP:
      return {
        ...state,
        open: false,
      };
    case setOpenPopupData:
      return {
        ...state,
      };
    default:
      return state;
  }
};
